<template>
  <div class="index">
    <div class="overview">
      <h2 class="overview-header">UI Components with Vue.js</h2>
      <div class="overview-demos">
        <k-row gutter="16">
          <k-col span="12">
            <k-button-group>
              <k-button icon="home-fill" />
              <k-button>Menu</k-button>
              <k-button>About</k-button>
              <k-button>Services</k-button>
              <k-button>Portfolio</k-button>
              <k-button>Contact</k-button>
            </k-button-group>
          </k-col>
          <k-col span="12">
            <k-divider>分割线</k-divider>
          </k-col>
        </k-row>

        <k-row gutter="16" style="margin-bottom:40px;">
          <k-col span="12">
            <p>
              <k-input value="kata" clearable placeholder="请输入.."></k-input>
            </p>
            <p><k-input showPwd placeholder="请输入.."></k-input></p>
            <k-input icon="search" placeholder="请输入.." circle></k-input>
          </k-col>
          <k-col span="12">
            <p>
              <k-input placeholder="请输入.." button="发送验证码"></k-input>
            </p>
            <p>
              <k-input
                icon="message"
                placeholder="请输入.."
                button="发送验证码"
                disabled
              ></k-input>
            </p>
            <k-input circle placeholder="请输入.." button="搜索"></k-input>
          </k-col>
        </k-row>

        <k-row gutter="16">
          <k-col span="13">
            <k-button icon="fast-backward" />
            <span class="divider" />
            <k-button icon="backward" />
            <span class="divider" />
            <k-button icon="caret-right" />
            <span class="divider" />
            <k-button icon="forward" />
            <span class="divider" />
            <k-button icon="fast-forward" />
            <span class="divider" />
            <span class="divider" />
            <k-switch></k-switch>
            <span class="divider" />
            <k-switch disabled></k-switch>
          </k-col>
          <k-col span="11">
            <k-button-group>
              <k-button icon="caret-left">上一页</k-button>
              <k-button>下一页 <k-icon type="caret-right"/></k-button>
            </k-button-group>
            <span class="divider" />
            <k-button-group>
              <k-button icon="appstore-fill" />
              <k-button icon="edit-fill" />
              <k-button icon="save-fill" />
              <k-button disabled icon="setting-fill" />
            </k-button-group>
          </k-col>
        </k-row>

        <k-row gutter="16" style="margin-bottom:40px;">
          <k-col span="13">
            <k-button icon="left-circle" circle />
            <span class="divider" />
            <k-button icon="minus-circle" circle />
            <span class="divider" />
            <k-button icon="play-circle" circle />
            <span class="divider" />
            <k-button icon="plus-circle" circle />
            <span class="divider" />
            <k-button icon="right-circle" circle />
            <span class="divider" />
            <span class="divider" />
            <k-switch loading></k-switch>
            <span class="divider" />
            <k-switch>
              <span slot="open">ON</span>
              <span slot="close">OFF</span>
            </k-switch>
          </k-col>
          <k-col span="11">
            <k-button-group circle>
              <k-button icon="left">上一页</k-button>
              <k-button>下一页 <k-icon type="right"/></k-button>
            </k-button-group>
            <span class="divider" />
            <k-button-group circle>
              <k-button icon="appstore" />
              <k-button icon="edit" />
              <k-button disabled icon="save" />
              <k-button icon="setting" />
            </k-button-group>
          </k-col>
        </k-row>

        <k-row gutter="16">
          <k-col span="12">
            <k-slider v-model="slider.value1"></k-slider>
            <k-slider v-model="slider.value2" range></k-slider>
          </k-col>
          <k-col span="12">
            <k-slider v-model="slider.value1" button="square"></k-slider>
            <k-slider v-model="slider.value2" range button="square"></k-slider>
          </k-col>
        </k-row>

        <k-row gutter="16">
          <k-col span="17">
            <k-button>普通按钮</k-button>
            <span class="divider" />
            <k-button icon="delete">删除</k-button>
            <span class="divider" />
            <k-button disabled>不可用</k-button>
            <span class="divider" />
            <k-button icon="save" disabled>保存</k-button>
            <span class="divider" />
            <k-button icon="save" disabled />
            <span class="divider" />
            <k-button loading>加载中</k-button>
            <span class="divider" />
            <k-button loading />
          </k-col>
          <k-col span="7">
            <k-select
              v-model="selectValue"
              @on-select-selected="handleSelectChange"
              style="width:200px;"
            >
              <k-option
                v-for="item in bookList"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </k-option>
            </k-select>
          </k-col>
        </k-row>

        <k-row gutter="16">
          <k-col span="17">
            <k-button circle>普通按钮</k-button>
            <span class="divider" />
            <k-button icon="delete" circle>删除</k-button>
            <span class="divider" />
            <k-button disabled circle>不可用</k-button>
            <span class="divider" />
            <k-button icon="save" disabled circle>保存</k-button>
            <span class="divider" />
            <k-button icon="save" disabled circle />
            <span class="divider" />
            <k-button loading circle>加载中</k-button>
            <span class="divider" />
            <k-button loading circle />
          </k-col>
          <k-col span="7">
            <k-select
              v-model="selectValue"
              circle
              @on-select-selected="handleSelectChange"
              style="width:200px;"
            >
              <k-option
                v-for="item in bookList"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </k-option>
            </k-select>
          </k-col>
        </k-row>

        <!-- <p>
        <k-row gutter="16">
          <k-col span="12"> </k-col>
          <k-col span="12"> </k-col>
        </k-row>
      </p> -->
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Index",
  data() {
    return {
      selectValue: "",
      bookList: [
        {
          value: "ISBN: 9787536692930",
          label: "《三体》"
        },
        {
          value: "ISBN: 9787108030429",
          label: "《文心》"
        },
        {
          value: "ISBN: 9787513910408",
          label: "《大众哲学》"
        },
        {
          value: "ISBN: 9787533935498",
          label: "《我所理解的生活》"
        },
        {
          value: "ISBN: 9787115470669",
          label: "《CSS世界》"
        },
        {
          value: "ISBN: 9787220101304",
          label: "《认识电影》"
        }
      ],
      slider: {
        value1: 25,
        value2: [20, 50]
      }
    };
  },
  methods: {
    handleSelectChange(selection) {
      this.$Message(`Label：${selection.label} Value：${selection.value}`);
    }
  }
};
</script>
<style lang="less">
.overview {
  width: 800px;
  margin: 0 auto;

  .overview-header {
    color: #c3c6c8;
    font-weight: 100;
    text-align: center;
  }
  .overview-demos {
    padding: 50px;
    overflow: hidden;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin-bottom: 16px;
    background-image: linear-gradient(#efefef 2px, transparent 0),
      linear-gradient(90deg, #efefef 2px, transparent 0),
      linear-gradient(#efefef 1px, transparent 0),
      linear-gradient(90deg, #efefef 1px, transparent 0);
    background-size: 75px 75px, 75px 75px, 15px 15px, 15px 15px;
    box-shadow: inset 0 0 6px 1px #e0e0e0;
    transition: box-shadow 0.2s linear;
    &:hover {
      box-shadow: inset 0 0 0px 2px #fff;
    }

    .divider {
      margin: 0 0.3em;
      color: #dcdcdc;
    }
  }
}
</style>
